import { Select } from '@artosera/ui';
import { useId } from 'react';
import { useTranslation } from 'react-i18next';
import { useLieux } from '../../api/lieux.js';
import { aplatirEmplacements, useEmplacements } from '../../api/reserve.js';
import { Field } from '../Field.js';
import styles from './InventairePage.module.css';

export function Destination({
  galerie,
  lieuId,
  emplacementId,
  onChange,
}: {
  galerie: string;
  lieuId: string;
  emplacementId: string;
  onChange: (lieuId: string, emplacementId: string) => void;
}) {
  const { t } = useTranslation('regie');
  const id = useId();
  const lieux = useLieux(galerie);
  const emplacements = useEmplacements(galerie);
  return (
    <div className={styles.formulaire}>
      <Field htmlFor={`${id}-lieu`} label={t('inventaire.lieu')}>
        <Select
          id={`${id}-lieu`}
          value={lieuId || 'aucun'}
          onValueChange={(v) => onChange(v === 'aucun' ? '' : v, '')}
          options={[
            { value: 'aucun', label: t('inventaire.choisir') },
            ...(lieux.data ?? [])
              .filter((l) => l.actif)
              .map((l) => ({ value: l.id, label: l.nom })),
          ]}
        />
      </Field>
      <Field htmlFor={`${id}-emplacement`} label={t('inventaire.emplacement')}>
        <Select
          id={`${id}-emplacement`}
          value={emplacementId || 'aucun'}
          onValueChange={(v) => onChange(lieuId, v === 'aucun' ? '' : v)}
          options={[
            { value: 'aucun', label: t('inventaire.sansEmplacement') },
            ...aplatirEmplacements(emplacements.data?.emplacements ?? [])
              .filter((e) => e.actif && e.lieuId === lieuId)
              .map((e) => ({ value: e.id, label: e.chemin })),
          ]}
        />
      </Field>
    </div>
  );
}
